<script lang="ts">
  import type { Writable } from "svelte/store";

  import PortalUserDropdown from "../../components/Business/PortalUserDropdown.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { IContact } from "../../entities";

  export let record: Writable<IContact>;
</script>

<div class="columns">
  <div class="column is-6">
    <FormField>
      <Input
        name="Nome"
        placeholder="Nome"
        required={true}
        bind:value={$record.firstName}
      />
    </FormField>
  </div>

  <div class="column is-6">
    <FormField>
      <Input
        name="Cognome"
        placeholder="Cognome"
        required={false}
        bind:value={$record.lastName}
      />
    </FormField>
  </div>
</div>

<div class="columns">
  <div class="column is-4">
    <FormField>
      <ClfDropdown
        name="Carica"
        schema="JBPOSITION"
        required={false}
        clearVisible={true}
        bind:value={$record.clfJobPositionId}
      />
    </FormField>
  </div>

  <div class="column is-4">
    <FormField>
      <ClfDropdown
        name="Ruolo"
        schema="JBROLEXXXX"
        required={false}
        clearVisible={true}
        bind:value={$record.clfJobRoleId}
      />
    </FormField>
  </div>

  <div class="column is-4">
    <FormField>
      <Input
        name="Privato / Azienda"
        placeholder=""
        required={false}
        maxlength={1}
        bind:value={$record.privateOrCompany}
      />
    </FormField>
  </div>
</div>

<div class="columns">
  <div class="column">
    <FormField>
      <DateInput
        name="Data Inizio Azienda"
        placeholder="inizio"
        required={false}
        bind:value={$record.companyStartDate}
      />
    </FormField>
  </div>

  <div class="column">
    <FormField>
      <DateInput
        name="Data Fine Azienda"
        placeholder="fine"
        required={false}
        bind:value={$record.companyEndDate}
      />
    </FormField>
  </div>
</div>

<!--
<div class="columns">
  <div class="column is-4">
    <FormField>
      <ClfDropdown
        name="Appellativo"
        schema="SALUTATION"
        required={false}
        clearVisible={true}
        bind:value={$record.clfSalutationId}
      />
    </FormField>
  </div>

  <div class="column is-8">
    <FormField>
      <Input
        name="Mansione"
        placeholder="Mansione"
        required={false}
        bind:value={$record.jobPosition}
      />
    </FormField>
  </div>
</div>

<div class="columns">
  <div class="column is-6">
    <FormField>
      <ClfDropdown
        name="Relazione"
        schema="RELATIONTP"
        required={false}
        clearVisible={true}
        bind:value={$record.clfRelationId}
      />
    </FormField>
  </div>

  <div class="column is-6">
    <FormField>
      <ClfDropdown
        name="Sorgente"
        schema="SOURCETYPS"
        required={false}
        clearVisible={true}
        bind:value={$record.clfSourceId}
      />
    </FormField>
  </div>
</div>
-->

<div class="columns">
  <div class="column">
    <FormField>
      <PortalUserDropdown
        name="Responsabile"
        required={false}
        clearVisible={true}
        bind:value={$record.responsibleUserId}
      />
    </FormField>
  </div>
</div>

<div class="columns">
  <div class="column">
    <FormField>
      <Textarea
        name="Note"
        placeholder="note"
        required={false}
        bind:value={$record.notes}
      />
    </FormField>
  </div>
</div>
